import { ApiService } from "@/domain/clients";
import { PamiaChatSession } from "@/domain/entities";
import { Endpoints } from "@/infra/api";
import { PamiaChatDataSource } from "./PamiaChatDataSource";

export class PamiaChatRemoteDataSource implements PamiaChatDataSource {
  constructor(private readonly api: ApiService) {}

  async getWebviewUrl(): Promise<PamiaChatSession> {
    const response = await this.api.get<PamiaChatSession>(
      Endpoints.pamia_webview_url,
    );

    return response.data as PamiaChatSession;
  }
}
